import { useContext, isValidElement } from 'react';
import { formInlineContext } from '../../visual-helper/FormInline';
import { twMerge } from 'tailwind-merge';
import RequiredBadge from '../../visual-helper/RequiredBadge';

type FormLabelProps = React.PropsWithChildren & React.ComponentPropsWithoutRef<'label'> & { required?: boolean };

function FormLabel(props: FormLabelProps) {
    const { required, children, className, ...rest } = props;
    const formInline = useContext(formInlineContext);

    const normalized = normalizeChildren(children, required);

    return (
        <label
            {...rest}
            className={twMerge(['inline-block mb-2', formInline && 'mb-2 sm:mb-0 sm:mr-5 sm:text-right', className])}
        >
            {normalized}
        </label>
    );
}

function normalizeChildren(children: React.ReactNode, required?: boolean) {
    if (typeof children === 'string') {
        const trimmed = children.trim();
        const hasStar = trimmed.endsWith('*');
        const text = hasStar ? trimmed.replace(/\s*\*$/, '') : trimmed;
        const showBadge = required || hasStar;
        if (!showBadge) return children;
        return (
            <span className="inline-flex items-center gap-1">
                <span>{text}</span>
                <RequiredBadge />
            </span>
        );
    }

    if (isValidElement(children)) {
        if (!required) return children;
        return (
            <span className="inline-flex items-center gap-1">
                {children}
                <RequiredBadge />
            </span>
        );
    }

    if (!required) return children;
    return (
        <span className="inline-flex items-center gap-1">
            {children}
            <RequiredBadge />
        </span>
    );
}

export default FormLabel;
